var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5848 3.2194L19.0648 9.9694C19.1999 10.1101 19.2758 10.301 19.2758 10.5C19.2758 10.699 19.1999 10.8899 19.0648 11.0306C18.9297 11.1714 18.7465 11.2504 18.5554 11.2504C18.3643 11.2504 18.1811 11.1714 18.046 11.0306L12.7954 5.5603V20.25C12.7954 20.4489 12.7195 20.6397 12.5845 20.7803C12.4494 20.921 12.2664 21 12.0754 21C11.8845 21 11.7013 20.921 11.5662 20.7803C11.4313 20.6397 11.3554 20.4489 11.3554 20.25V5.5603L6.1048 11.0306C5.9697 11.1714 5.78646 11.2504 5.5954 11.2504C5.40433 11.2504 5.2211 11.1714 5.086 11.0306C4.9509 10.8899 4.875 10.699 4.875 10.5C4.875 10.301 4.9509 10.1101 5.086 9.9694L11.566 3.2194C11.6329 3.1496 11.7123 3.0943 11.7997 3.0566C11.8871 3.0188 11.9808 2.9994 12.0754 2.9994C12.17 2.9994 12.2637 3.0188 12.3511 3.0566C12.4385 3.0943 12.5179 3.1496 12.5848 3.2194Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTop);
export default __webpack_public_path__ + "static/media/_arrow-top.158a313c1f15f3d4f287ec05d433dc11.svg";
export { ForwardRef as ReactComponent };